module.exports = __webpack_public_path__ + "static/media/ET078-N new.34a41656.jpg";